<section class="info-banner">
  <div class="info-banner__content">
    <div class="info-banner__carousel">
      @for (count of bannerCount; track $index) {
        <div class="info-banner__carousel_group">
          @for (item of merqueeItems; track $index) {
            <div class="info-banner__carousel_item">
              <img loading="lazy" src="assets/icons/banner-check.svg" alt="banner-check" />

              <div class="info-banner__carousel_text">
                {{ item | translate }}
              </div>
            </div>
          }
        </div>
      }
    </div>

    <div class="info-banner__content_overlay"></div>
  </div>
</section>
